import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryComponent } from './history.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    HistoryComponent
  ],
  imports: [
    CommonModule,
    NgbPopoverModule
  ],
  exports:[
    HistoryComponent
  ]
})
export class HistoryModule { }
